module.exports = {"pathContext":{"slug":"/en/lowdamage/","langKey":"en"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/en-lowdamage.json
// module id = 1553
// module chunks = 245123762025081